export default {
  content: {
    languages: {
      en: "English",
    },
  },
}
